var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"CreateProfile d-flex flex-column h-100"},[_c('Headline',[_vm._v(" Create a new profile ")]),_c('Notice'),_c('create-or-update',{on:{"cancel":_vm.onCancel,"submit":_vm.onSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }